import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
// @ts-expect-error migrate upstream files
import ErrorMessage from 'reporting-ui-components/components/shared/ErrorMessage';
// @ts-expect-error migrate upstream files
import ErrorBoundary from '../shared/ErrorBoundary';
// @ts-expect-error migrate upstream files
import { getId as getDashboardId } from 'dashboard-lib/public/dashboard/dashboard-schema';
import { getDataType, getId as getReportId, getTemplateName
// @ts-expect-error migrate upstream files
} from 'dashboard-lib/public/report/report-schema';
import { isNoteWidget, isStaticWidget
// @ts-expect-error migrate upstream files
} from 'dashboard-lib/public/report/report-logic';
import { capture } from 'dashboard-lib/public/sentry/report-management-sentry';
import { WIDGET_ERROR_BOUNDARY } from 'dashboard-lib/public/sentry/sentry-event-id';
import { createFingerprint } from 'dashboard-lib/public/sentry/sentry-fingerprint';
import { WidgetContext } from './WidgetContext';
import { DashboardCardHeader } from './common/DashboardCardHeader';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StaticWidgetError = ({
  report
}) => /*#__PURE__*/_jsx(UIFlex, {
  direction: "column",
  align: "center",
  justify: "center",
  children: /*#__PURE__*/_jsx(Text, {
    textAlign: "center",
    children: isNoteWidget(report) ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "noteWidget.error"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "iframeWidget.renderError"
    })
  })
});
const DashboardWidgetErrorBoundary = props => {
  const {
    children,
    dashboard,
    report
  } = props;
  const ErrorComponent = ({
    error
  }) => {
    const widgetError = isStaticWidget(report) ? /*#__PURE__*/_jsx(StaticWidgetError, {
      report: report
    }) : /*#__PURE__*/_jsx(ErrorMessage, {
      error: error
    });
    return /*#__PURE__*/_jsxs(WidgetContext.Provider, {
      value: {
        dashboard,
        dashboardFilters: [],
        overriddenReport: report,
        report
      },
      children: [/*#__PURE__*/_jsx(DashboardCardHeader, {}), widgetError]
    });
  };
  const onError = error => {
    capture(WIDGET_ERROR_BOUNDARY, {
      error,
      extra: {
        dashboardId: getDashboardId(dashboard),
        template: getTemplateName(report),
        dataType: getDataType(report),
        reportId: getReportId(report)
      },
      fingerprint: createFingerprint(error)
    });
  };
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    onError: onError,
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      name: WIDGET_ERROR_BOUNDARY,
      ErrorComponent: ErrorComponent,
      onError: onError,
      children: children
    })
  });
};
export default DashboardWidgetErrorBoundary;